var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "消息通知设置",
        visible: _vm.visible,
        width: "552px",
        "append-to-body": true,
        center: "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "fix-form" },
        [
          _c("div", { staticClass: "label-title" }, [
            _vm._v("1.当审批单被拒绝时，通知以下节点人员:"),
          ]),
          _c(
            "el-checkbox-group",
            {
              staticClass: "check-group",
              model: {
                value: _vm.checkList,
                callback: function ($$v) {
                  _vm.checkList = $$v
                },
                expression: "checkList",
              },
            },
            [
              _c(
                "el-checkbox",
                { attrs: { label: "onRejectionNotifyAllBeforeRejection" } },
                [
                  _c("span", { staticClass: "name-text" }, [
                    _vm._v("拒绝节点前的所有人"),
                  ]),
                ]
              ),
              _c(
                "el-checkbox",
                { attrs: { label: "onRejectionNotifyOtherOrSignApprovers" } },
                [
                  _c("span", { staticClass: "name-text" }, [
                    _vm._v("或签节点的其他或签审批人"),
                  ]),
                ]
              ),
              _c(
                "el-checkbox",
                { attrs: { label: "onRejectionNotifyOtherAndSignApprovers" } },
                [
                  _c("span", { staticClass: "name-text" }, [
                    _vm._v("会签节点的其他会签审批人"),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "label-title" }, [
            _vm._v("2.当审批单被同意时，通知以下节点人员:"),
          ]),
          _c(
            "el-checkbox-group",
            {
              staticClass: "check-group",
              model: {
                value: _vm.checkList,
                callback: function ($$v) {
                  _vm.checkList = $$v
                },
                expression: "checkList",
              },
            },
            [
              _c(
                "el-checkbox",
                { attrs: { label: "onApprovalNotifyOtherOrSignApprovers" } },
                [
                  _c("span", { staticClass: "name-text" }, [
                    _vm._v("或签节点的其他或签审批人"),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.save } },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }